import { HookAPI } from 'antd/es/modal/useModal'

export function ErrorView(modal: HookAPI, title: string, err: any) {
  return modal.error({
    title: title,
    content: <>{err.toString()}</>,
  })
}
